var React = require('react');

function HorizontalSeparator (props) {
    return React.createElement("svg",props,React.createElement("line",{"id":"Line_18","data-name":"Line 18","x1":"135","transform":"translate(0 0.5)","fill":"none","stroke":"#000","strokeWidth":"1"}));
}

HorizontalSeparator.defaultProps = {"width":"135","height":"1","viewBox":"0 0 135 1"};

module.exports = HorizontalSeparator;

HorizontalSeparator.default = HorizontalSeparator;
